import { HttpClient } from '@angular/common/http';
import { MmuTranslateFileLoaderBase } from './mmu-translate-file-loader-base';

/**
 * @deprecated: This loader is deprecated and will soon be removed, because cache busting is not supported.
 * Please extend and use the class MmuTranslateFileLoaderBase in future! You should use esnext import statements for translation
 * files in order to support cache busting.
 *
 * For reference, please see:
 * https://github.com/ngx-translate/http-loader/issues/25#issuecomment-641184284
 */
export class MmuTranslateFileLoaderService extends MmuTranslateFileLoaderBase {

  constructor(private http: HttpClient,
              public prefix: string = '/assets/i18n/',
              public suffix: string = '.json') {
    super();
  }

  protected loadLanguageForLocale(locale: string) {
    return this.http.get(`${this.prefix}${locale}${this.suffix}`);
  }
}
